import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { CrmTasks } from "@/components/crm/CrmTasks";
import { CrmCampaigns } from "@/components/crm/CrmCampaigns";
import { CrmImport } from "@/components/crm/CrmImport";

const triggerCls = "data-[state=active]:bg-amber-400 data-[state=active]:text-[#0D1117] font-semibold uppercase text-xs tracking-wider";

export const CrmView = ({ isAdmin = false, customers = [], users = [], dateFrom = "", dateTo = "", onCustomersChanged }) => {
  return (
    <div data-testid="crm-view" className="space-y-4">
      <div>
        <p className="font-mono text-xs text-amber-400 tracking-widest uppercase">CRM</p>
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight">Planowanie i akcje marketingowe</h2>
      </div>
      <Tabs defaultValue="tasks">
        <TabsList data-testid="crm-subtabs" className="bg-card border border-border flex-wrap h-auto justify-start gap-1 p-1">
          <TabsTrigger value="tasks" data-testid="crm-subtab-tasks" className={triggerCls}>Zadania</TabsTrigger>
          <TabsTrigger value="campaigns" data-testid="crm-subtab-campaigns" className={triggerCls}>Kampanie</TabsTrigger>
          <TabsTrigger value="import" data-testid="crm-subtab-import" className={triggerCls}>Import klientów</TabsTrigger>
        </TabsList>
        <TabsContent value="tasks" className="mt-4">
          <CrmTasks isAdmin={isAdmin} customers={customers} users={users} dateFrom={dateFrom} dateTo={dateTo} />
        </TabsContent>
        <TabsContent value="campaigns" className="mt-4">
          <CrmCampaigns isAdmin={isAdmin} />
        </TabsContent>
        <TabsContent value="import" className="mt-4">
          <CrmImport isAdmin={isAdmin} users={users} onImported={onCustomersChanged} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
